module.exports = __webpack_public_path__ + "img/qanda-icon.d9f3a808.png";